import React from 'react';
import { Box, CircularProgress, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
}));

export interface LoadingSpinnerProps {
  /**
   * Minimum height of the loading container
   * @default '400px'
   */
  minHeight?: string;
  
  /**
   * Size of the circular progress indicator
   * @default 40
   */
  size?: number;
  
  /**
   * Additional className for styling
   */
  className?: string;
  
  /**
   * Inline styles
   */
  style?: React.CSSProperties;
}

/**
 * Standardized loading spinner component for DFP plugins
 * Provides consistent loading UI across all components
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  minHeight = '400px',
  size = 40,
  className,
  style,
}) => {
  const classes = useStyles();

  return (
    <Box
      className={`${classes.container} ${className || ''}`}
      style={{ minHeight, ...style }}
    >
      <CircularProgress size={size} />
    </Box>
  );
};
